import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import { tokenMiddleware } from '../api/tokenMiddleware';
import loadingSlice from '../features/misc/loadingSlice';
import projectReducer from '../features/projects/projectSlice';
import nodeReducer from '../features/projects/nodeSlice';
import deviationReducer from '../features/projects/deviationSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    loader: loadingSlice,
    project: projectReducer,
    node: nodeReducer,
    deviation: deviationReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(tokenMiddleware),
});

// Define y exporta el tipo RootState
export type RootState = ReturnType<typeof store.getState>;

export default store;
